// components/Carousel.js
'use client'
import Image from 'next/image'
import { useEffect, useState } from 'react'

const Carousel = () => {
  const images = [
    // { src: '/icons/landingImg1.svg', alt: 'land1' },
    // { src: '/icons/landingImg1.svg', alt: 'land2' },
    // { src: '/icons/landingImg1.svg', alt: 'land3' },
    { src: '/images/carouseldefault.png', alt: 'default carousel image' },
    { src: '/images/carousel1.jpg', alt: 'land1' },
    { src: '/images/carousel2.jpg', alt: 'land2' },
    { src: '/images/carousel3.jpg', alt: 'land3' },
  ]

  const [currentIndex, setCurrentIndex] = useState(0)
  // Automatically change slides every 2 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1))
    }, 5000) // 2000 ms = 2 seconds

    return () => clearInterval(interval) // Cleanup on unmount
  }, [currentIndex])

  // const nextSlide = () => {
  // 	setCurrentIndex((prevIndex) =>
  // 		prevIndex === images.length - 1 ? 0 : prevIndex + 1,
  // 	);
  // };

  // const prevSlide = () => {
  // 	setCurrentIndex((prevIndex) =>
  // 		prevIndex === 0 ? images.length - 1 : prevIndex - 1,
  // 	);
  // };

  return (
    <div className='relative w-full min-h-[300px] md:min-h-[400px] lg:min-h-[380px]'>
      {/* Carousel Container */}
      <div
        className={`
        relative overflow-hidden w-full min-h-[300px] rounded-lg
        md:h-[400px] lg:h-[380px] md:rounded-xl
      `}
      >
        <div
          className={`
            whitespace-nowrap transition-transform duration-500 ease-in-out min-h-[300px]
            md:h-full
          `}
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {images.map((image, index) => (
            <div
              key={index}
              className='inline-block w-full min-h-[300px] relative rounded-lg md:rounded-xl overflow-hidden md:h-full'
            >
              <Image src={image.src} alt={image.alt} fill className='object-cover' />
            </div>
          ))}
        </div>
      </div>

      {/* Previous and Next Buttons */}
      {/* <button
        type="button"
        onClick={prevSlide}
        className="absolute top-0 left-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
      >
        <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none">
          <svg
            className="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 6 10"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 1 1 5l4 4"
            />
          </svg>
          <span className="sr-only">Previous</span>
        </span>
      </button>
	  <button
        type="button"
        onClick={nextSlide}
        className="absolute top-0 right-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
      >
        <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none">
          <svg
            className="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 6 10"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 9 4-4-4-4"
            />
          </svg>
          <span className="sr-only">Next</span>
        </span>
      </button> */}

      {/* Indicator Dots */}
    </div>
  )
}

export default Carousel
